import { compact, isArray, isString } from 'lodash';

const TRACKING_JOINER = ' - ';

function trimStringList(stringList) {
  if (isArray(stringList)) {
    return compact(
      stringList.map((item) => {
        return isString(item) ? item.trim() : item;
      }),
    );
  } else {
    return compact(stringList);
  }
}

export const TRACKING_CONSTANT = {
  CYCLE_TOGGLE_BILLED: (billingCycle) => `toggled billed ${billingCycle}`.toLowerCase(),
  LICENSE_CHANGE: (billingCycle, newLicese, oldLicense) =>
    trimStringList([billingCycle, newLicese > oldLicense ? 'increase' : 'decrease', newLicese]).join(TRACKING_JOINER),
  IMPRESSION: (...info) => trimStringList([...info, 'impression']).join(TRACKING_JOINER),
};
